export default {
      id: "icon-messagethin-usage",
      viewBox: "0 0 33 32",
      url: __webpack_public_path__ + "icons.svg#icon-messagethin",
      toString: function () {
        return this.url;
      }
    }